var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M24.0002 21.4652C25.0854 21.4652 25.9652 20.5854 25.9652 19.5002C25.9652 18.4149 25.0854 17.5352 24.0002 17.5352C22.9149 17.5352 22.0352 18.4149 22.0352 19.5002C22.0352 20.5854 22.9149 21.4652 24.0002 21.4652Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M18.465 26.5352C17.385 26.5352 16.5 27.4202 16.5 28.5002C16.5 29.5802 17.385 30.4652 18.465 30.4652C19.545 30.4652 20.43 29.5802 20.43 28.5002C20.43 27.4202 19.545 26.5352 18.465 26.5352Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M29.5353 26.5352C28.4553 26.5352 27.5703 27.4202 27.5703 28.5002C27.5703 29.5802 28.4553 30.4652 29.5353 30.4652C30.6153 30.4652 31.5003 29.5802 31.5003 28.5002C31.5003 27.4202 30.6153 26.5352 29.5353 26.5352Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore2);
export default __webpack_public_path__ + "static/media/more2.86461f260cfd6c27d62d9adcae53ad3a.svg";
export { ForwardRef as ReactComponent };